module.exports = __webpack_public_path__ + "img/ico-dot.65326d0d.svg";